import React from "react";
import PropTypes from "prop-types";
import { Skeleton } from "antd";

const PlaceholderLineLoader = ({ count = 1 }) => (
  <>
    {[...Array(count).keys()].map((key) => (
      <Skeleton
        key={key}
        active
        paragraph={{ rows: 2 }}
        title={{ width: "60%" }}
      />
    ))}
  </>
);

PlaceholderLineLoader.propTypes = {
  count: PropTypes.number,
};

export default PlaceholderLineLoader;
